import {
  createSlice,
  //   createSelector,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { uncoveryApi } from "services";

const options = {
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

const collectionCreateAdapter = createEntityAdapter();
const initialState = collectionCreateAdapter.getInitialState({
  createOneStatus: "idle",
  createOneErrorMessage: "",
  createdCollection: null,
});

export const createOneCollection = createAsyncThunk(
  "collectionCreate/createOneCollection",
  async ({ entityId, payload }, { rejectWithValue }) => {
    const query = `/entities/${entityId}/assets/collections`;
    if (payload?.connectors) {
      payload.connectors = payload.connectors.map((e) => {
        return { id: e.value };
      });
    }
    try {
      const response = await uncoveryApi.post(query, payload, options);
      if (response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const collectionCreateSlice = createSlice({
  name: "collectionCreate",
  initialState,
  reducers: {
    resetCollectionCreateState: () => initialState,
  },
  extraReducers: {
    [createOneCollection.pending]: (state, { payload }) => {
      state.createOneStatus = "loading";
    },
    [createOneCollection.fulfilled]: (state, { payload }) => {
      state.createdCollection = payload.data;
      state.createOneStatus = "success";
    },
    [createOneCollection.rejected]: (state, { payload }) => {
      state.createOneErrorMessage = payload.message;
      state.createOneStatus = "error";
    },
  },
});

export const { resetCollectionCreateState } = collectionCreateSlice.actions;

export default collectionCreateSlice.reducer;

// const collectionCreateState = (state) => state.collectionCreate;

// export const selectCollectionIds = createSelector(
//   collectionCreateState,
//   (collections) => collections.data.map((collection) => collection.id)
// );
// export const selectCollections = createSelector(
//   collectionCreateState,
//   (collections) => collections.data
// );
// export const selectCollectionById = createSelector(
//   [
//     collectionCreateState,
//     (collectionCreateState, collectionId) => collectionId,
//   ],
//   (collections, collectionId) =>
//     collections.data.find((collection) => collection.id === collectionId)
// );
